/**
 * Can be used by some plugins to have a "global" object that
 * can be imported and mutated at will.
 */
export const RXDB_UTILS_GLOBAL: any = {};


export const PREMIUM_FLAG_HASH = '6da4936d1425ff3a5c44c02342c6daf791d266be3ae8479b8ec59e261df41b93';
